// The search by id the admin SPA makes: the PCM calls and parked DLQ events Power keeps under an
// interaction id, event id or trace id. Power normalizes the id; one it cannot read is its 400.
import { HttpClientRequest } from 'effect/http';
import { OperationsSearchResult } from '@finnest/power-admin-contracts';
import type { OperationsSearchResult as OperationsSearchResultType } from '@finnest/power-admin-contracts';
import { READ_BUDGET, decoded, within } from './http.ts';
import type { OperationsOperation } from './http.ts';

const SEARCH_PATH = '/power/admin/operations/search';

/** What Power keeps under `id`, as the operator typed it. */
export const searchById =
  (id: string): OperationsOperation<OperationsSearchResultType> =>
  (apiBaseUrl) =>
    within(READ_BUDGET)(
      decoded(
        HttpClientRequest.get(`${apiBaseUrl}${SEARCH_PATH}`).pipe(
          HttpClientRequest.setUrlParams({ id }),
        ),
        OperationsSearchResult,
      ),
    );
